import { Progress as ChakraProgress, ProgressProps } from '@chakra-ui/react';

export type ProgressBarProps = ProgressProps;

/**
 * ProgressBar is used to display the progress status for a task that takes a long time or consists of several steps.
 */
const ProgressBar = (props: ProgressBarProps) => {
  return <ChakraProgress max={100} min={0} {...props} />;
};

export default ProgressBar;
